import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'

export const formatName = (firstName: string | null = '', lastName: string, fullName?: string): string => {
    if (firstName === 'Anonymous') {
        return firstName
    }
    if (fullName) {
        return fullName
    }
    return stringEscapeNewlines(''.concat(firstName || '', ' ', lastName || '').trim())
}
